import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-36ebb070")

_pushScopeId("data-v-36ebb070")
const _hoisted_1 = {
  key: 0,
  class: "p-megamenu-panel",
  ref: "megamenu"
}
const _hoisted_2 = { class: "p-grid p-mb-1" }
const _hoisted_3 = { class: "p-input-icon-left p-col" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = { style: {"overflow-y":"auto"} }
const _hoisted_6 = { class: "p-megamenu-data" }
const _hoisted_7 = { class: "p-megamenu-submenu" }
const _hoisted_8 = { class: "p-menuitem-text" }
const _hoisted_9 = { class: "p-menuitem-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Message = _resolveComponent("Message")
  const _component_router_link = _resolveComponent("router-link")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_ctx.model && _ctx.openedPanelEvent)
    ? (_openBlock(), _createBlock("ul", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.searchText,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchText = $event)),
              placeholder: _ctx.$tc('common.search'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.focusInput($event))),
              onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter()))
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          (_ctx.tmpModel.length === 0)
            ? (_openBlock(), _createBlock(_component_Message, {
                key: 0,
                severity: "warn",
                style: {"min-width":"400px"},
                closable: false
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.info.emptySearch')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tmpModel, (column, columnIndex) => {
              return (_openBlock(), _createBlock("div", {
                key: column.label + '_column_' + columnIndex,
                class: "menuColumn p-mb-3"
              }, [
                _createVNode("ul", _hoisted_7, [
                  _withDirectives(_createVNode("li", {
                    role: "presentation",
                    class: "kn-truncated"
                  }, _toDisplayString(_ctx.$t(column.label)), 513), [
                    [
                      _directive_tooltip,
                      _ctx.$t(column.label),
                      void 0,
                      { top: true }
                    ]
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(column.items, (item, i) => {
                    return (_openBlock(), _createBlock("li", {
                      key: item.label + i.toString(),
                      role: "none",
                      style: item.style
                    }, [
                      (item.to && !item.disabled)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: item.to,
                            custom: ""
                          }, {
                            default: _withId(({ navigate, href }) => [
                              _createVNode("a", {
                                href: href,
                                role: "menuitem",
                                onClick: ($event: any) => (_ctx.onLeafClick($event, item, navigate))
                              }, [
                                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(item.label)), 1)
                              ], 8, ["href", "onClick"])
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : (_openBlock(), _createBlock("a", {
                            key: 1,
                            href: item.url,
                            target: item.target,
                            onClick: ($event: any) => (_ctx.onLeafClick($event, item, _ctx.navigate)),
                            role: "menuitem",
                            tabindex: item.disabled ? null : '0'
                          }, [
                            _createVNode("span", _hoisted_9, _toDisplayString(item.label), 1)
                          ], 8, ["href", "target", "onClick", "tabindex"]))
                    ], 4))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ])
      ], 512))
    : _createCommentVNode("", true)
})